import { z } from 'zod'

import { CreateInstallationSchema } from './CreateInstallation'

export interface InstallationIntegration {
  id: string | null
  integrationType: string
  hostname?: string | null
  port?: string | null
  user?: string | null
  password?: string | null
  customFields?: Record<string, string> | null
  centerId?: string | null
  startFacturationDate?: string | null
  deactivatedAt?: string | null
}

export const InstallationSchema = CreateInstallationSchema.extend({
  installationId: z.string(),
  timeZone: z.string().optional().nullable(),
  salesIntegration: z.boolean().optional(),
  workspace: z
    .union([
      z.literal(''),
      z.null(),
      z
        .string()
        .trim()
        .min(1)
        .transform((value) => value.toLowerCase())
        .pipe(z.string().regex(/^[a-z]+$/, { message: 'common:lettersOnly' })),
    ])
    .optional(),
})

export type Installation = z.infer<typeof InstallationSchema> & {
  softwareIntegrations?: Array<InstallationIntegration>
  stockIntegrations?: Array<InstallationIntegration>
}
